var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-layout',{attrs:{"view":"hhh lpr fff"}},[_c('HeaderComponent'),_c('q-page-container',[_c('router-view')],1),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }